import React from "react";
import ReactDOM from "react-dom";
import { make as App } from "../src/frontend/App.bs.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
require("maker-ds/dist/maker-ds-purged.css");
const app = document.getElementById("app");
ReactDOM.render( /*#__PURE__*/_jsx(App, {}), app);
